import Wait from '@react/react-spectrum/Wait';
import React, {useState} from 'react';
import Banner from '@react/react-spectrum/Banner';
import './AppHomeCardIcon.scss';

type Props = {
	text: string;
	link: string;
	imgUrl: string;
	type: string;
	title: string;
	loadDelay: number;
	comingSoon?: boolean;
	spinner: boolean;
	apphomeData: any;
	intl: any;
};

export const AppHomeCardIcon = (props: Props) => {
	const [isLoading, setLoading] = useState(false);

	const handleDelay = async(e) => {
		if (props.comingSoon) {
			e.preventDefault();
			return false;
		}
		e.preventDefault();
		setLoading(true);
		await new Promise((res) => setTimeout(res, props.spinner ? props.loadDelay : 0));
		window.location.href = props.link;
	};

	return (
		<div
			key={`${props.type}`}
			className={`apphome-card action-row-card action-${props.type}`}
			onClick={handleDelay}
			tabIndex={0}
		>
			<p className={`action-${props.type}-text`}>
				<span className={`action-${props.type}-faded-text`}>{props.title}</span>
				<span className={`action-${props.type}-title`}>{props.text}</span>
			</p>
			<div className={`action-${props.type}-img-container`}>
				<img className={`action-${props.type}-img`} src={props.imgUrl} alt={props.text} />
			</div>
			{props.spinner && isLoading && (
				<div className={`action-${props.type}-loading`}>
					<Wait size='M' centered variant='overBackground' />
				</div>
			)}
			{props.comingSoon && (
				<div className={`action-${props.type}-banner-container`}>
					<Banner
						className={`action-${props.type}-banner`}
						corner
						content={props.intl.formatMessage({id: 'app.apphomes.soon'})}
					/>
				</div>
			)}
		</div>
	);
};

export default AppHomeCardIcon;
